import { callApiNew } from 'api/axios'
import { PATHS } from 'api/paths'
import {
  ACTIVITY_LEVEL_NAME,
  HEALTH_TOOL_NAME,
  HealthToolGender,
} from 'interfaces/constants/healthTools'
import { CareEmbeddedType, InjectCareInfo, LOCALE } from 'interfaces/types'

/**
 * @param careEmbedded care embedded like '/type="doctor"/id="123"'
 * @returns
 */
const formatInjectedCareInfo = (careEmbedded: any): InjectCareInfo | null => {
  if (typeof careEmbedded !== 'string') {
    return null
  }

  return {
    type: (/type="(.*?)"/gi.exec(careEmbedded)?.[1] || '') as CareEmbeddedType,
    dataId: /id="(.*?)"/gi.exec(careEmbedded)?.[1] || '',
    dataTitle: /title="(.*?)"/gi.exec(careEmbedded)?.[1] || '',
    dataDescription: /description="(.*?)"/gi.exec(careEmbedded)?.[1] || '',
  }
}

const addResultToLink = (link: string) => {
  return link.includes('?result=1')
    ? link
    : link.includes('?')
    ? link.replace('?', '?result=1&')
    : link + '?result=1'
}
const calcRecommendMinWeight = (height: number, locale = LOCALE.Vietnam) =>
  Number((Math.pow(height / 100, 2) * 18.5).toFixed(1)).toLocaleString(locale)

const calRecommendMaxWeight = (height: number, locale = LOCALE.Vietnam) =>
  Number(
    (
      Math.pow(height / 100, 2) * (locale === LOCALE.Taiwan ? 23.9 : 22.9)
    ).toFixed(1),
  ).toLocaleString(locale)

export type CalculateCaloriesProps = {
  weight: string | number
  height: string | number
  activityLevel: ACTIVITY_LEVEL_NAME
  age: string | number
  gender: HealthToolGender
}

const calculateCalories = async ({
  weight,
  height,
  activityLevel = ACTIVITY_LEVEL_NAME.LOW_INTENSITY,
  age,
  gender = 'male',
}: CalculateCaloriesProps) =>
  await callApiNew(PATHS.HEALTH_TOOL.CALCULATE_CALORIES, {
    params: {
      weight,
      height,
      activityLevel: getActivityLevelNumberVal(activityLevel),
      age,
      gender,
    },
  })

export const getActivityLevelNumberVal = (value: ACTIVITY_LEVEL_NAME) => {
  return Object.values(ACTIVITY_LEVEL_NAME).indexOf(value) + 1
}

export const getActivityLevelVal = (number = 1) => {
  return Object.values(ACTIVITY_LEVEL_NAME)?.[number] || ''
}

export const checkBMRStatus = ({
  gender,
  bmr: _bmr,
}: {
  gender: 'male' | 'female'
  bmr: string | number
}) => {
  const bmr = Number(_bmr)
  if (gender === 'male') {
    return bmr < 1600 ? 'low' : bmr > 1800 ? 'high' : 'normal'
  } else {
    return bmr < 1200 ? 'low' : bmr > 1400 ? 'high' : 'normal'
  }
}

export {
  formatInjectedCareInfo,
  addResultToLink,
  calcRecommendMinWeight,
  calRecommendMaxWeight,
  calculateCalories,
}

export type ToolPageType = 'form' | 'result' | 'records'

export const HEALTH_TOOL_COMMON_CONFIGS = {
  [HEALTH_TOOL_NAME.BMI]: 'blue',
  [HEALTH_TOOL_NAME.BMR]: 'green',
  [HEALTH_TOOL_NAME.THR]: 'red',
}
